/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBORGANISATIONCLASSIFICATION = {
    NonFinancialInstitution: '02',
    FinancialInstitution: '01'
} as const;
export type GHUBORGANISATIONCLASSIFICATION = typeof GHUBORGANISATIONCLASSIFICATION[keyof typeof GHUBORGANISATIONCLASSIFICATION];


export function GHUBORGANISATIONCLASSIFICATIONFromJSON(json: any): GHUBORGANISATIONCLASSIFICATION {
    return GHUBORGANISATIONCLASSIFICATIONFromJSONTyped(json, false);
}

export function GHUBORGANISATIONCLASSIFICATIONFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBORGANISATIONCLASSIFICATION {
    return json as GHUBORGANISATIONCLASSIFICATION;
}

export function GHUBORGANISATIONCLASSIFICATIONToJSON(value?: GHUBORGANISATIONCLASSIFICATION | null): any {
    return value as any;
}

